import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App/App';
import * as serviceWorker from './serviceWorker';
import {createFeatureHub} from '@feature-hub/core';
import {defineLogger} from '@feature-hub/logger';
import {FeatureHubContextProvider, FeatureAppContainer} from '@feature-hub/react';
import {defineExternals, loadAmdModule} from '@feature-hub/module-loader-amd';
import { ServicioAutenticacion } from 'autenticacion_servicio';
import { ServicioFirebase } from 'servicio-firebase';
import * as firebaseApp from 'firebase/app';
import * as firebaseAnalytics from 'firebase/analytics';
import * as firebaseMessaging from 'firebase/messaging';
import * as FeatureHubReact from '@feature-hub/react';

defineExternals({
  react: React,
  'firebase/app': firebaseApp,
  'firebase/analytics': firebaseAnalytics,
  'firebase/messaging': firebaseMessaging,
  '@feature-hub/react': FeatureHubReact
});

const {featureAppManager} = createFeatureHub('dto:kmi:integrator',{
    featureServiceDefinitions: [
        defineLogger(),
        ServicioAutenticacion,
        ServicioFirebase
    ],
    moduleLoader: loadAmdModule,
    providedExternals: {react: '17.0.1'}
});

ReactDOM.render(
  <FeatureHubContextProvider value={{featureAppManager}}>
    <section>
      <FeatureAppContainer featureAppId="dto:kmi:app" featureAppDefinition={App} />
    </section>
  </FeatureHubContextProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();